import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import '../styles/member.css';
import { MDBBadge, MDBBtn } from 'mdb-react-ui-kit';
import { createMemberCart, getGymAddonsList, getGymPlansList, getMemberCart } from '../../services/memberApiServices';
import { useCart } from './CartContext.js';
import { Link, useNavigate } from 'react-router-dom';
import shape from '../../memberportal/assets/images/badge-shap.png';
import loadingcart from '../../memberportal/assets/images/plan-loader.gif';
import emptycart from '../../memberportal/assets/images/empty-cart.png';

const ViewCart = () => {
    const [allMembership, setAllMembership] = useState([]);
    const [cartMembership, setCartMembership] = useState([]);

    const {
        cart,
        loading,
        removeFromCart,
        clearCart,
        fetchCart,
        getGymId
    } = useCart();
    const navigate = useNavigate();

    useEffect(() => {
        if (cart) {
            if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                navigate('/memberlogin', { state: { path: '/viewcart' } })
            }
            fetchPlansAndAddons();
        }
    }, [cart]);
    console.log(cart, 'cart');


    useEffect(() => {
        if (cart && allMembership.length > 0) {
            const cartItemIds = cart.membershipitems.map(item => item.itemid);
            const filtered = allMembership.filter(item =>
                cartItemIds.includes(item._id)
            );
            setCartMembership(filtered);
            // setLoading(false);
        }
    }, [allMembership, cart]);

    async function fetchPlansAndAddons() {
        const userInfo = getGymId();
        if (!userInfo) return;

        let mergedMembership = [];

        // Fetch Plans
        const plansResponse = await getGymPlansList(userInfo);
        if (plansResponse && plansResponse !== "false") {
            const plansData = await plansResponse.json();

            const formattedPlans = plansData
                .filter(plan => plan.archived !== true)
                .flatMap(plan => {
                    let entries = [];

                    entries.push({
                        ...plan,
                        type: "plan",
                        duration: plan.numberofdays === 1 ? "1 Day" :
                            plan.numberofdays === 7 ? "1 Week" :
                                plan.numberofdays === 30 ? "1 Month" :
                                    `${plan.numberofdays} Days`
                    });

                    if (plan.subplans && plan.subplans.length > 0) {
                        const subplanEntries = plan.subplans.map(sp => ({
                            ...sp,
                            parentId: plan._id,
                            parentName: plan.name,
                            type: "plan",
                            displayName: `${plan.name} - ${sp.name}`,
                            duration: sp.numberofdays === 1 ? "1 Day" :
                                sp.numberofdays === 7 ? "1 Week" :
                                    sp.numberofdays === 30 ? "1 Month" :
                                        `${sp.numberofdays} Days`
                        }));
                        entries = [...entries, ...subplanEntries];
                    }

                    return entries;
                });

            mergedMembership = [...mergedMembership, ...formattedPlans];
        }

        // Fetch Addons
        const addonsResponse = await getGymAddonsList(userInfo);
        if (addonsResponse && addonsResponse !== "false") {
            const addonsData = await addonsResponse.json();
            const enabledAddons = addonsData
                .filter(addon => addon.enable === true)
                .map(addon => ({
                    ...addon,
                    type: "addons",
                    duration: addon.rentbasis === "1" ? "1 Day" :
                        addon.rentbasis === "2" ? "1 Week" :
                            addon.rentbasis === "3" ? "1 Month" :
                                "Custom Duration"
                }));
            mergedMembership = [...mergedMembership, ...enabledAddons];
        }

        console.log("mergedMembership", mergedMembership);
        setAllMembership(mergedMembership);
    }


    const getDefaultFeatures = (item) => {
        if (item.type === 'plan') {
            return [
                `Valid for ${item.numberofdays} days`,
                item.sessioncheck ? `${item.sessionvalue} sessions included` : 'Unlimited sessions',
                item.autocheckin ? 'Auto check-in enabled' : 'Manual check-in required'
            ];
        } else {
            return [
                `Gender: ${item.gender === '1' ? 'Male' : item.gender === '2' ? 'Female' : 'Unisex'}`,
                `Rental basis: ${item.rentbasis === '1' ? 'Daily' : item.rentbasis === '2' ? 'Weekly' : 'Monthly'}`,
                ...(item.props?.map(prop => prop.name) || [])
            ];
        }
    };



    console.log(cartMembership, 'cartMembership');
    const handleCheckout = () => {
        navigate('/memberbilling', { state: { cartItems: cartMembership } })
    }

    if (loading) {
        return (
            <div className="dashboard-container">
                <Sidebar />
                <div className="main-content">
                    <Header title={"Cart"} iscart={true} />
                    <div className="dashboard-content">
                        <div className="loading-spinner">
                            <img src={loadingcart} alt="" />
                            <h4 className='ms-3'>Loading cart...</h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!cart || cartMembership.length === 0) {
        return (
            <div className="dashboard-container">
                <Sidebar />
                <div className="main-content">
                    <Header title={"Your Cart"} iscart={true} />
                    <div className="dashboard-content">
                        <div className="empty-cart-message">
                            <img src={emptycart} alt="cart" />
                            <h4 className='mt-2'>Your cart is empty</h4>
                            <label>Look like you have not added anything to you cart. Go ahead & explore top categories.</label>
                            <MDBBtn
                                className="explore-btn nav-btn mt-3 "
                                onClick={() => navigate('/membershipplans')}
                            >

                                <span>  <i className="fas fa-search me-2"></i> Explore More </span>
                            </MDBBtn>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-container">
            <Sidebar />
            <div className="main-content">
                <Header title={"Your Cart"} iscart={true} />
                <div className="dashboard-content">
                 
                    <div className=' h-100'>

                        <div className='flex-grow-1 d-flex flex-column h-100'>
                            <div className="custom-btn-cler">
                                <button class="filter-btn cancel-btn me-2" onClick={() => clearCart()}>
                                    <i class="fa-solid fa-eraser me-2"></i> Clear Cart
                                </button>
                            </div>

                            <div className='flex-grow-1 position-relative' style={{ height: 'calc(100% - 26px)', overflow: 'auto' }}>
                                <div className="plans-grid">
                                    {cartMembership.map((item, index) => (
                                        <div className="plan-card" key={item._id}>
                                            <div className="plan-header">
                                                <h4 className="plan-name">
                                                    {item?.displayName ? item?.displayName : item.name}
                                                </h4>

                                            </div>

                                            <ul className="plan-features">
                                                {getDefaultFeatures(item).map((feature, idx) => (
                                                    <li key={idx}> <i class="fa-solid fa-circle-check me-1 text-secondary"></i> {feature}</li>
                                                ))}
                                            </ul>

                                            <div className='d-flex align-items-center justify-content-center my-3'>
                                                <div className='position-relative'>
                                                    <div className="plan-price"><i class="fa-solid fa-indian-rupee-sign"></i> <span>
                                                        {Number(item?.price ?? item?.props?.[0]?.propvalue ?? 0).toLocaleString('en-IN')}
                                                    </span> <label className="plan-duration">{item?.duration}</label></div>
                                                    {item?.sessioncheck && (
                                                        <span className="spots-remaining">
                                                            {item?.sessionvalue} Sessions
                                                        </span>
                                                    )}
                                                </div>

                                            </div>

                                            <div className="plan-description">
                                                <label class="text-secondary">Description</label>
                                                <p className='m-0'> {item?.description || 'No description available'}</p>
                                            </div>

                                           
                                            <MDBBadge
                                                pill
                                                className="ms-2 type-badge"
                                                color={item?.type === "plan" ? "primary" : "success"}
                                            >
                                                <i className="fas fa-tag me-1"></i>  {item?.type === "plan" ? "Plan" : "Addon"}
                                            </MDBBadge>
                                            <div className="plan-footer">

                                                <MDBBtn onClick={() => removeFromCart(item._id)} className="nav-btn trash-nav-btn">
                                                    <span className=''>  <i className="fas fa-trash menu-icon"></i>  Remove</span>
                                                </MDBBtn>

                                                <MDBBtn onClick={() => navigate('/memberbilling', { state: { cartItems: [item] } })} className="nav-btn">
                                                    <span className=''>  <i className="fas fa-credit-card menu-icon"></i>  Buy Now</span>
                                                </MDBBtn>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="cart-actions">
                                <button
                                    className="btn nav-btnoutline"
                                    onClick={() => navigate('/membershipplans')}
                                >
                                    <i className="fas fa-search me-2"></i>
                                    Explore More
                                </button>


                                <MDBBtn onClick={() => {
                                    handleCheckout()
                                }} className="nav-btn">
                                    <span className=''>  <i className="fas fa-credit-card me-2"></i>  Checkout</span>
                                </MDBBtn>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewCart;